import { Paragraph, WrapLgMarginBottom } from "App/global-style";
import {
  AlertTitle,
  Button,
} from "Components/TextContext/commonComponentEnums";

import { CoopBenefits } from "Components/Partner/CoopBenefits/CoopBenefits";
import { useTexts } from "Components/TextContext";
import { Variants } from "Components/TextContext/textConstants";
import { removeWhitespace } from "Formatting/index";
import { userIdentificationStart } from "Store/userIdentification/userIdentificationSlice";
import { buttonTrackId } from "Utils/analytics";
import { isDefined } from "Utils/functions";
import React from "react";
import { useDispatch } from "react-redux";
import { ProductBackendName } from "../../Products/productTypes";
import { LoginForm, PreviousButtonProps } from "./LoginForm";
import { useBankIdLoginHandler } from "./bankIdLoginHooks";
import { NoLoginFormValues } from "./loginFormValues";
import { StyledButton } from "./styled";

interface Props extends PreviousButtonProps {
  readonly productBackendName: ProductBackendName;
  readonly isLoading: boolean;
  readonly validNameNin: boolean | undefined;
  readonly customerMaxAge?: number;
  readonly showBankIdMotivation?: boolean;
}
export const DefaultLogin = ({
  productBackendName,
  validNameNin,
  isLoading,
  showBankIdMotivation = true,
  previousButton = undefined,
}: Props): React.ReactElement => {
  const dispatch = useDispatch();
  const handleBankIdLogin = useBankIdLoginHandler();
  const { getText } = useTexts();

  const handleNoLogin = (formValues: NoLoginFormValues): void => {
    dispatch(
      userIdentificationStart({
        ssn: removeWhitespace(formValues.nin),
        firstName: formValues.firstName,
        lastName: formValues.lastName,
        products: productBackendName,
      }),
    );
  };

  return (
    <>
      {showBankIdMotivation && (
        <WrapLgMarginBottom>
          <Paragraph>{getText(AlertTitle.NO_BANK_ID)}</Paragraph>
          {isDefined(handleBankIdLogin) && (
            <StyledButton
              data-trackid={buttonTrackId(
                getText(AlertTitle.NO_BANK_ID, { variant: Variants.ENGLISH }),
              )}
              onClick={() => handleBankIdLogin()}
            >
              {getText(Button.LOGIN_BANKID)}
            </StyledButton>
          )}
        </WrapLgMarginBottom>
      )}

      <LoginForm
        onSubmit={handleNoLogin}
        isLoading={isLoading}
        validNameNin={validNameNin}
        previousButton={previousButton}
      />

      <CoopBenefits />
    </>
  );
};
